<template>
  <table>
    <tr style="font-size: medium">
      <td>
        <span class="badge" style="color: black"
          >Total a tratar : {{ cantSuspATratar }}
        </span>
      </td>
    </tr>
  </table>
</template>
<script>
import Vue from "vue";
import { isNil } from "lodash-es";

export default Vue.extend({
  name: "CantidadDeSuspensionesATratar",
  computed: {
    modo() {
      return this.$store.state.Suspensiones.suspensionesMODO;
    },
    cantSuspATratar() {
      const deudores = this.$store.getters["Suspensiones/getDeudores"] || [];
      let contador = 0;

      for (let i = 0; i < deudores.length; i++) {
        const deudor = deudores[i];
        if (this.modo === "evitar") {
          if (deudor.a_tratar && deudor.a_tratar > 0) {
            contador++;
          }
        } else {
          if (isNil(deudor.fecha_reconex) && deudor.fecha_alta) {
            contador++;
          }
        }
      }

      return contador;
    },
  },
});
</script>
